import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { UserAsset } from '@models/dashboard.model';
import { getCarrier } from '@models/functions.model';
import { ShoppingCartData, ShoppingCartItem } from '@models/shopping-cart.model';
import { ActivityManagerService } from '@services/activity/manager/activity-manager.service';
import { ShoppingService } from '@services/shopping/shopping.service';
import { TranslationService } from '@services/translation/translation.service';
import { Subscription } from 'rxjs';

import { AssetSelectionComponent } from '../selection/asset-selection.component';

@Component({
  selector: 'ts-asset-selection-screen',
  templateUrl: './asset-selection-screen.component.html',
  imports: [AssetSelectionComponent]
})
export class AssetSelectionScreenComponent {
  asset: UserAsset | undefined;
  activity_id: number;
  shopping_cart: ShoppingCartData;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private activity_manager_svc: ActivityManagerService,
    private shopping_svc: ShoppingService,
    private translation_svc: TranslationService
  ) {}

  ngOnInit(): void {
    this.activity_id = this.activity_manager_svc.state().orderTypeId();

    this.subscriptions.add(
      this.shopping_svc.getShoppingItems().subscribe({
        next: (res: ShoppingCartData) => {
          this.shopping_cart = res;
        },
        error: (err: HttpErrorResponse) => {}
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get header(): string | undefined {
    if ([8, 12].includes(this.activity_id))
      return this.translation_svc.translate('my_eligible_lines');
    return undefined;
  }

  get no_asset_text(): string | undefined {
    if ([8, 12].includes(this.activity_id))
      return this.translation_svc.translate('no_eligible_lines');
    return undefined;
  }

  get asset_fields(): string[] {
    switch (this.activity_id) {
      case 8:
        return ['plan', 'contract_end_date', 'add_on_features'];
      case 12:
        return ['plan', 'plan_features', 'add_on_features'];
      default:
        return [];
    }
  }

  get shopping_cart_items(): ShoppingCartItem[] {
    return this.shopping_cart.existing_asset?.device?.id != this.asset?.device?.id ||
      this.shopping_cart.existing_asset?.line?.id != this.asset?.line?.id
      ? []
      : this.shopping_cart.shopping_cart_items;
  }

  selectAsset(asset: UserAsset): void {
    this.asset = { ...asset, asset_selection_case: 1 };

    this.shopping_svc.sendShoppingItems(this.shoppingCartParam(), true).subscribe({
      next: (res: ShoppingCartData) => {
        this.activity_manager_svc.navigateToNextStep();
      },
      error: (err: HttpErrorResponse) => {}
    });
  }

  private shoppingCartParam(): ShoppingCartData {
    const param: ShoppingCartData = {
      ...this.shopping_cart,
      country_id:
        this.asset?.line.country_id ?? this.activity_manager_svc.state().parameter('country')?.id,
      carrier: this.asset?.line && getCarrier(this.asset.line),
      orderTypeId: this.activity_manager_svc.currentOrderTypeId(),
      order_for_person: this.shopping_cart.order_for_person,
      lineId: this.asset?.line.id,
      existing_asset: this.asset!,
      progress_stepper: this.activity_manager_svc
        .state()
        .currentStep(this.activity_manager_svc.state().activeStepIndex())
    };

    param.shopping_cart_items = this.shopping_cart_items;

    return param;
  }
}
